import { getCookie } from "cookies-next";
import { COOKIES_TAGS } from "../../../functions/cookies/COOKIES_TAGS";
import secretApiAxios from "../../endpoints/core/secretApiAxios";
import { SetLog, TagLogs } from "../../logs/set-log";

export const _FindLead = async ({ id, email, context }) => {
  try {
    try {
      id = id ? id : getCookie(COOKIES_TAGS.LEAD_ID, context);
    } catch (error) {}
    if (email) {
      return await secretApiAxios
        .get(
          `leads?filters[email][$eq]=${email}&sort[id]=desc&populate=conta,usina,contrato_plano_usina`
        )
        .then((data) => {
          return data.data?.data[0];
        })
        .catch((err) => {
          SetLog(
            TagLogs.error_find_lead,
            { function: "Erro ao buscar o lead", errorMessage: err.message },
            false
          );
          return false;
        });
    }
    const currentLead = id
      ? await secretApiAxios
          .get(
            `leads/${parseInt(id)}?populate=conta,usina,contrato_plano_usina`
          )
          .then((data) => data.data?.data)
          .catch((err) => {
            SetLog(
              TagLogs.error_find_lead,
              { function: "Erro ao buscar o lead", errorMessage: err.message },
              false
            );
            return false;
          })
      : false;

    return getFilteredLeadData(currentLead);
  } catch (error) {
    return false;
  }
};

function getFilteredLeadData(data) {
  return data;
}
